import { create } from "zustand";
import { persist } from 'zustand/middleware';

const useCheckoutStore = create(
  persist((set, get) => ({
    storePage: null,
    setStorePage: (value) => set({ storePage: value }),
    reservation: null,
    setReservation: (value) => set({ reservation: value }),
    pricePreview: 0,
    setPricePreview: (value) => set({ pricePreview: value }),
    selectedBookableDuration: null,
    setSelectedBookableDuration: (value) => set({ selectedBookableDuration: value }),
    selectedDates: [],
    setSelectedDates: (value) => set({ selectedDates: value }),
    customer: null,
    setCustomer: (value) => set({ customer: value }),
    location: null,
    setLocation: (value) => set({ location: value }),
    reset: () => set({
      storePage: null,
      reservation: null,
      pricePreview: 0,
      selectedBookableDuration: null,
      selectedDates: [],
      reservations: [],
      location: null,
      order: null,
    }),

    order: null,
    setOrder: (value) => set({ order: value }),

    reservations: [],
    setReservations: (value) => set({ reservations: value }),
    updateReservation: (updatedReservation) => set((state) => ({
      reservations: state.reservations.map((reservation) => reservation.id === updatedReservation.id ? { ...reservation, ...updatedReservation } : reservation)
    })),
    addReservation: (reservation) => set((state) => ({
      reservations: [reservation, ...state.reservations]
    })),
    removeReservation: (removedReservation) => set((state) => ({
      reservations: state.reservations.filter((reservation) => removedReservation.id !== reservation.id)
    }))
  }), {
    name: 'checkout-storage', // unique name
  })
);

export default useCheckoutStore;